export const ENVIRONMENT = process.env.NODE_ENV || "development";
export const REACT_APP_API_URL =
  process.env.REACT_APP_API_URL || "http://localhost:3001";
export const REACT_APP_DOMAIN = process.env.REACT_APP_DOMAIN || "localhost";
